<div class="ds-toggle-button">
  <label class="ds-toggle-button-label d-flex">
    <input class="ds-toggle-button__input" type="checkbox"
           [checked]="isChecked"
           [disabled]="isDisabled"
           [(ngModel)]="value"
           ngModel>
    <ng-container *ngIf="label">
      <span class="ds-toggle-button__text ds-body">{{label}}</span>
    </ng-container>
    <span class="ds-toggle-button__toggle"></span>
    <span class="ds-toggle-button__on ds-body">{{on}}</span>
    <span class="ds-toggle-button__off ds-body">{{off}}</span>
  </label>
</div>
